import React, { useCallback, useEffect, useState } from 'react';
import { Card, Box, Typography } from '@mui/material';
import CircularLoadingContainer from '../../../../components/loaders/CircularLoadingContainer';
import useAnalytics from '../../../../hooks/api/useAnalytics';
import Chart, {useChart} from '../../../../components/chart';
import { catalogs } from '../../../../utils/catalogs';

const EnergyLevelChart = ({
    start_date, end_date, client_id, client_location_id, client_program_id
}) => {

    const [loading, setLoading] = useState(false)
    const [analytics, setAnalytics] = useState({})
    const analyticsManager = useAnalytics()

    const initialize = useCallback(async() => {
        if(loading) return
        setLoading(true)
        try {
            const params = {start_date: start_date, end_date:end_date, 
                client_id: client_id > 0 ? client_id : undefined,
                client_location_id: client_location_id > 0 ? client_location_id : undefined,
                client_program_id: client_program_id > 0 ? client_program_id : undefined,
            }
            let result = []
            const _energy_level_analytics = await analyticsManager.actions.onGetUsersByEnergyLevelStatus(params)

            for(let i=0; i<catalogs.energy_levels.length; i++){
                let diagnosis = catalogs.energy_levels[i]
                const elFound = _energy_level_analytics.find(el => el.energy_level_id === diagnosis.value)
                result.push(elFound ? elFound.user_count : 0)
            }

            ///let expectionObj =  _imc_analytics.find(el => el.objective_id === null)
            ///result.push(expectionObj ? expectionObj.user_count : 0)
            //console.log(result)



            setAnalytics(result)
        } catch (error) {
            console.log(error)
        }

        setLoading(false)
    }, [loading, start_date, end_date, client_id, client_location_id, client_program_id])

    useEffect(() => {
        initialize()
    }, [start_date, end_date, client_id, client_location_id, client_program_id])



    return ( 
        <Card
            sx={{px:2, py:2, minHeight:'100%'}}
        >
            <CircularLoadingContainer loading={loading} />
            <Typography variant='subtitle2'>Sintomatología por nivel de energía</Typography>
            <Box>
                <EnergyLevelPieChart series={analytics} />
            </Box>
        </Card>
     );
}
 
export default EnergyLevelChart;


const EnergyLevelPieChart = ({series}) => {

    let _options = [
        ...catalogs.energy_levels,
        //{value:-1, label:'Sin clasificar', color:grey[300]}
    ]

    const chartOptions = useChart({
        labels: _options.map((el) => el.label),
        legend: {
            position:'bottom'
        },
        colors:_options.map((el) => el.color)
    })


    return(
    <Box
        sx={{
            width:'100%',
            maxWidth:500,
            margin:'auto'
        }}
        
    >
        <Chart
            type="pie" 
            series={series} 
            options={chartOptions}
        />
    </Box>
    )
}
